<template>
<div class="center">
  <div class="box w-mob my-3" style="top:20vh;">
    <h1 class="title is-3 has-text-centered has-text-grey">{{ $t('PasswordReset.title') }}</h1>
      <form @submit.prevent="passwordReset">
        <div class="field">
        <p v-if="error" class="has-text-info">{{ $t('PasswordReset.error') }}: {{ error.message }}</p>
          <label class="label">{{ $t('PasswordReset.email') }}</label>
          <div class="control">
            <input class="input" type="text" id="inputUsername" v-model="username" required>
          </div>
          <p class="help">{{ $t('PasswordReset.note') }}</p>
        </div>
        <button class="button is-info is-fullwidth mt-05">{{ $t('PasswordReset.restoreAccess') }}</button>
      </form>
      <div class="pt-05 has-text-centered">
          <router-link to="/login" class="button is-white has-text-grey">{{ $t('PasswordReset.login') }}</router-link>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      username: "",
      error: null
    };
  },
  methods: {
    passwordReset() {
      this.$cognitoAuth.forgotPassword(this.username, (err, result) => {
        if (err) {
          this.error = err;
          console.error(err);
        } else {
          console.log("Password reset successful:", result);
          this.$router.replace("/confirm_reset_password");
        }
      });
    }
  },
  mounted() {
    this.$title = this.$t('title') + " | " + this.$t('PasswordReset.title')
  }
};
</script>

<style>
.error {
  color: red;
}
</style>
